import type AttendeeType from 'owa-service/lib/contract/AttendeeType';

export function formatAttendeeArray(attendees: AttendeeType[]) {
    return attendees
        ? attendees
              .map(attendee =>
                  attendee.Mailbox
                      ? attendee.Mailbox.Name + ' <' + attendee.Mailbox.EmailAddress + '>;'
                      : ''
              )
              .join(' ')
        : '';
}
